import React, { useEffect, useState } from 'react'
import MyPDFViewer from '../components/PDFViewer'
import { useLocation } from 'react-router';
import axiosInstance from '../axios/axios';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslate } from '../components/TranslationText';
import Loader from '../components/Loader';

export default function DigitalCatalog() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const { translate } = useTranslate();
    const currentId = searchParams.has("showId") ? searchParams.get("showId") : '';
    const [pdfUrl, setPdfUrl] = useState('');
    const [loading, setloading] = useState(false);
    const [loaded, setloaded] = useState(false);
    const baseURL = process.env.REACT_APP_BACKEND_SCOURING_API;


    async function getPdfLink() {
        try {
            setloading(true);
            const res = await axiosInstance.get(`/api/Shows/DownloadDigitalCatalog?showId=${currentId}`,{baseURL:baseURL});
            if (res.status == 200) {
                if (res.data?.status?.responseCode == "200") {
                    setPdfUrl(res.data?.result);
                    setloaded(true);
                    setloading(false);
                } else {
                    const errormsg = 'The Digital Catalog Is Not Available Yet';
                    toast.error(translate(errormsg, errormsg))
                    setloading(false);
                }
            }


        } catch (error) {

            setloading(false);
        }

    }

    useEffect(() => {
        getPdfLink();
    }, [])

    return (
        <>
            <ToastContainer
                position="top-right"
                closeOnClick
                theme="colored"
                autoClose={5000}
            />
            {loading &&
                <div className='text-center'>
                <Loader />
                </div>
            }
            {loaded == true &&
                <div>
                    <MyPDFViewer pdfUrl={pdfUrl} />
                </div>
            }
        </>
    )
}
